'use client'
import React, { FC } from 'react'
import classNames from 'classnames'

import styles from './ToggleSwitch.module.css'

import { styled } from '@mui/material/styles'
import Switch, { SwitchProps } from '@mui/material/Switch'

const StyledSwitch = styled((props: SwitchProps) => (
	<Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
	width: 40,
	height: 22,
	padding: 0,
	'& .MuiSwitch-switchBase': {
		padding: 0,
		margin: 2,
		transitionDuration: '150ms',
		'&.Mui-checked': {
			transform: 'translateX(16px)',
			color: '#fff',
			'& + .MuiSwitch-track': {
				background: 'linear-gradient(135deg, #B491FF 2.88%, #3300FF 98.14%)',
				opacity: 1,
				border: 0
			},
			'&.Mui-disabled + .MuiSwitch-track': {
				opacity: 0.5
			}
		},
		'&.Mui-focusVisible .MuiSwitch-thumb': {
			color: 'linear-gradient(135deg, #B491FF 2.88%, #3300FF 98.14%)',
			border: '6px solid #fff'
		},
		'&.Mui-disabled .MuiSwitch-thumb': {
			color: 'var(--gray-200)'
		},
		'&.Mui-disabled + .MuiSwitch-track': {
			opacity: '0.3'
		}
	},
	'& .MuiSwitch-thumb': {
		boxSizing: 'border-box',
		width: 18,
		height: 18
	},
	'& .MuiSwitch-track': {
		borderRadius: 26 / 2,
		backgroundColor: 'var(--gray-500)',
		opacity: 1,
		transition: theme.transitions.create(['background-color'], {
			duration: 150
		})
	}
}))

const ToggleSwitch: FC<{
	className?: string
	checked?: boolean
	onChange?: (checked: any) => void
}> = (props) => {
	const { checked, onChange, className } = props

	const handleOnChange = React.useCallback(
		(e: any) => {
			onChange && onChange(e.target.checked)
		},
		[onChange]
	)

	return (
		<StyledSwitch
			checked={checked}
			className={classNames({ [(props.className as any)]: !!className }, styles.root)}
			onChange={handleOnChange}
		/>
	)
}

export default ToggleSwitch
